import PropTypes from 'prop-types';

export const favoritesPropTypes = PropTypes.arrayOf(PropTypes.number);
